import {Tabs} from "antd";
import {InventoryTable} from './InventoryTable';
import {ProductTable} from "./ProductTable";
import {BulkInventoryInput} from "./BulkInventoryInput";
import {NewProduct} from "./NewProduct";
import {InventoryHelp} from "./InventoryHelp";
import {CategoryType} from "../../api/Constants";
import {AllBatchView} from "../cultivation/AllBatchView";

export const InventoryTab = ({refresh, onRefresh, addToCart, onApiFail, props}) => {
    const onNewInventory = () => {
        onRefresh();
    }

    const items = [
        {
            key: 'AllProduct',
            label: 'Product List',
            children: <ProductTable refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'AllInventory',
            label: 'Inventory',
            children: <InventoryTable enableCSV={true} refresh={refresh} onApiFail={onApiFail} />
        },
        {
            key: 'LowInventory',
            label: 'Low Inventory',
            children: <InventoryTable enableCSV={true} refresh={refresh} onApiFail={onApiFail} lowInventoryAlert={true}/>
        },
        {
            key: 'BulkWholesale',
            label: 'Batch Bulk/Wholesale',
            children: <BulkInventoryInput refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'NewBulk',
            label: 'New Wholesale Product',
            children: <NewProduct category={CategoryType.Wholesale} refresh={refresh} onApiFail={onApiFail} onUpdate={onNewInventory}/>
        },
        {
            key: 'NewPackaged',
            label: 'New Packaged Product',
            children: <NewProduct category={CategoryType.Packaged} refresh={refresh} onApiFail={onApiFail} onUpdate={onNewInventory}/>
        },
        {
            key: 'NewSupply',
            label: 'New Supply Product',
            children: <NewProduct category={CategoryType.Supplies} refresh={refresh} onApiFail={onApiFail} onUpdate={onNewInventory}/>
        },
        {
            key: 'Batches',
            label: 'Batches',
            children: <AllBatchView refresh={refresh} onRefresh={onRefresh} onApiFail={onApiFail} />
        },
        {
            key: 'Help',
            label: 'Help',
            children: <InventoryHelp />
        }
    ];

    const onTabChange = () => {
        console.log('on tab change');
    }


    return <Tabs defaultActiveKey={'AllInventory'} tabPosition={'left'} items={items} onChange={onTabChange}/>
}